import React, { useState } from 'react';
import axios from 'axios';
import '../../styles/Auth.css';

const ChangePassword = ({ onLogout }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    axios.post('https://assistente.restauranteindaia.com.br/change-password', 
      { old_password: oldPassword, new_password: newPassword },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then(response => {
      alert('Senha alterada com sucesso');
      onLogout();
    })
    .catch(() => {
      alert('Erro ao alterar a senha');
    });
  };

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleSubmit}>
        <h2>Trocar Senha</h2>
        <div>
          <label>Senha Atual</label>
          <input type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
        </div>
        <div>
          <label>Nova Senha</label>
          <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
        </div>
        <button type="submit">Alterar Senha</button>
      </form>
    </div>
  );
};

export default ChangePassword;
